// --- web 端存储 ---
// 盲盒token
export const BlindToken = 'BlindToken';
// 盲盒用户id
export const BlindUserId = 'BlindUserId';
// 盲盒用户等级
export const BlindUserLevel = 'BlindUserLevel';

// 针对支付宝h5支付轮询判断是否需要详情页开盒
export const isNoOpenBox = 'isNoOpenBox';

// java token
export const token = 'token';
// php token
export const blackToken = 'dolphin_token';
export const blackToken2 = 'dolphin_token_from_jssdk';
// 骑士卡用户id
export const cardMenberId = 'member_id';
// localstorage 链接记录
export const lastLink = 'last_link';
// 道具卡
export const luckyCardInfo = 'luckyCardInfo';
// userId
export const userId = 'userId';

// 金卡会员
export const vipCardStatus = 'memberStatus'; // 金卡会员状态
export const vipCardTask = 'task/vip-card'; // 金卡任务
export const orchardTask = 'task/orchard'; // 果园
export const vipCardBackCount = 'vip-card/BackCount'; // 临时，history.back 返回页数

// 整点抽大奖
export const recordDate = 'getRecordDate'; // 是否当天

// --- 临时存储 ---
// 微信 openid
export const openId = 'openId';
// 微信 code
export const code = 'code';
// 微信验证后 location.href 跳转的页面
export const authBackUrl = 'authBackUrl';
// 微信验证后需要使用的 backCount
export const BackCount = 'BackCount';


// --- 客户端存储 ---
// 示例
export const C_TEST = 'C_TEST';

// --- 地址 ---
export const addressId = 'addressId';

// 猜你喜欢
export const feedBackHidden = 'feedBackHidden';

// 萌骑骑积分系统
export const dailyUpdateNotice = 'dailyUpdateNotice';

// 充电得宝
export const jwt = 'jwt';

export const blindMarketChannel = 'blindBoxChannelId'; // 盲盒渠道

export const blindBoxOrderInfo = 'blindBoxOrderInfo'; // 盲盒信息

// 推广相关参数
// 推广api回传参数
export const BlindTgApiData = 'BlindTgApiData';

export const needUpdateDeliveryCalculate = 'needUpdateDeliveryCalculate'; // 需要重新计算邮费

// 不显示Tabbar
export const noShowTabbarList = ['xiaomai01'];

// 是否为提审版本
export const isTaiShen = 'isTaiShen';
// 提审客服开关
export const isTaiShenKF = 'isTaiShenKF';

// 换取token登录日期
export const LoginDate = 'LoginDate';
